import { parseErrorMessage } from '../../../core/api/api.context';
import { ConfirmationModal } from '../../../ui/components/pure/modal-content/confirmation-modal.component';
import { useMutationApproveCarrier } from '../carriers.queries';

export interface CarrierModalProps {
  carrier: { id: string; name: string };
  onSuccess(): void;
  onCancel(): void;
}

export function ApproveCarrierModal({ carrier, onSuccess, onCancel }: CarrierModalProps) {
  const approveMutation = useMutationApproveCarrier();

  return (
    <ConfirmationModal
      title="Approve Carrier?"
      content={[carrier.name, 'This clears the carrier’s ‘Needs Review’ flag.']}
      isLoading={approveMutation.isLoading}
      errorMessage={approveMutation.error ? parseErrorMessage(approveMutation.error.message) : undefined}
      onConfirm={() => approveMutation.mutate(carrier.id, { onSuccess })}
      onCancel={onCancel}
      noteRequired={false}
      actionButton={{ label: 'Approve', color: 'primary' }}
      cancelButton={{ label: 'Cancel', color: 'secondary' }}
    />
  );
}
